const planLimit = (state) => {
  return state.plan.limit
}

export default {
  planLimit,
}
